module.exports = __webpack_public_path__ + "img/Agreement.7f7e1e80.png";